export default "__VITE_ASSET__0b109ba1__"